import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'

export function RedirectRoute() {
  const location = useLocation()

  return <Navigate to="/dashboard" state={{ from: location }} replace />
}
